import React from "react";
import {connect} from "react-redux";
import {loadData} from "../../actions/store/storeActions";
import StoreItemsScreen from "./StoreItemsScreen";
import StoreCheckOutScreen from "./StoreCheckOutScreen";
import LogInScreen from "../login/LogInScreen";
import EcheckForm from "../pay/EcheckForm";
import EBTForm from "../pay/EBTForm";
import {setShouldReloadData, setDirty, setAndRemoveUrlParams} from '../../actions/common/commonActions';
import {initServerStaticData} from "../../actions/common/staticDataActions";
import {FetchingTypes, CATEGORY_QRY, ITEM_QRY, CART_ITEM_QRY, ORIGIN_CATEGORY_SELECTED, ORIGIN_ITEM_SELECTED, URLs} from '../../common/constants';
import MessagePage from "../../components/common/MessagePage";
import ThankYouPage from "../../components/common/ThankYouPage";
import PaymentsHost from "../pay/PaymentsHost";
import {initMemberData} from "../../actions/login/memberDetailsActions";
import LoadingAnimation from "../../components/common/LoadingAnimation";
import {isFetching} from "../../actions/common/fetchingActions";
import {redirectPage, getUrlParams} from '../../common/utils';
import {setMessageData} from "../../actions/common/messagePageActions";

class StoreHomeScreen extends React.Component {
    state = {
        page: "LoadingAnimation"
    };

    componentWillMount() {
        const params = getUrlParams();
        this.props.initServerStaticData();
        if (params.mode !== 'preview')
            this.props.initMemberData();
        this.props.setAndRemoveUrlParams(false);
    }

    getInitialDataForLoad = (nextProps) => {
		return {
            category: this._getCategoryFromLocation(nextProps),
            itemKey: this._getItemFromLocation(nextProps),
            staticData: nextProps.staticData,
            location: nextProps.location,
            memberKey: nextProps.memberDetails.key,
            flowType: URLs.STORE
        };
	};

    componentDidMount() {
	    //If the order is restored from the storage
	    if (this.props.orderStatus.currentOrder)
            this.props.restoreOrder();
        else
            this.props.setShouldReloadData(!this.props.orderStatus.currentOrder);
	}

    _getOrigin = () => {
        if(this.props.location.hash.startsWith(ITEM_QRY)){
            return ORIGIN_ITEM_SELECTED;
        }else {
            return ORIGIN_CATEGORY_SELECTED;
        }
    };

    _getCategoryFromLocation = (nextProps) => {
        if(nextProps.location.hash.startsWith(CATEGORY_QRY)){
            return nextProps.location.hash.slice((CATEGORY_QRY+"=").length);
        }
        if(nextProps.location.hash.startsWith(CART_ITEM_QRY)){
            const categoryStart = location.hash.indexOf(CATEGORY_QRY)
            return nextProps.location.hash.slice(categoryStart + (CATEGORY_QRY+"=").length);
        }
	};

    _getItemFromLocation = (nextProps) => {
        if(nextProps.location.hash.startsWith(ITEM_QRY)){
            return nextProps.location.hash.slice((ITEM_QRY+"=").length);
        }
        if(nextProps.location.hash.startsWith(CART_ITEM_QRY)){
            const categoryStart = location.hash.indexOf(CATEGORY_QRY);
            return nextProps.location.hash.slice((CART_ITEM_QRY+"=").length, categoryStart);
        }
    };

    getPath = (staticData) => {
        window.location.replace(redirectPage(URLs.STORE, staticData));
    };

    componentWillReceiveProps(nextProps) {
        this.getPage(nextProps);
    }

    getPage = (props) => {
        const path = props.location.pathname;
        if (props.errorFetching)
            this.setState({page: "ErrorFetching"});
        else if (props.isLoadingStoreData){
            this.setState({page: "LoadingAnimation"});
        } else if ((props.messageData || {}).messageTitle && !(props.messageData || {}).isStoreClosedWithMultiOrders) {
            this.setState({page: "MessagePage"});
        } else if (path.endsWith('/checkout')) {
            if (props.orderStatus.currentOrder) {
                this.setState({page: "StoreCheckOutScreen"});
            } else {
                this.getPath(props.staticData);
            }
        } else if (path.endsWith('/login')) {
            if(props.memberDetails.key) {
                this.getPath(props.staticData);
            } else {
                this.setState({page: "LogInScreen"});
            }
        } else if (path.endsWith('/thankyou')) {
            this.setState({page: "ThankYouPage", shouldReloadPage: true});
        } else if (path.endsWith('/echeck')) {
            if (props.orderStatus.currentOrder) {
                this.setState({page: "EcheckForm"});
            } else {
                this.getPath(props.staticData);
            }
        } else if (path.endsWith('/ebt')) {
            if (props.orderStatus.currentOrder) {
                this.setState({page: "EBTForm"});
            } else {
                this.getPath(props.staticData);
            }
        } else if (path.endsWith('/payments')) {
            if (props.orderStatus.currentOrder) {
                this.setState({page: "PaymentsHost"});
            } else {
                this.getPath(props.staticData);
            }
        } else if (this.state.shouldReloadPage) {
            window.location.reload();
        } else if (props.staticData.showStoreOnlyForMembers && !props.memberDetails.key) {
            this.setState({page: "LogInScreen"});
        } else {
            if (props.shouldReloadData) {
                props.onLoad(this.getInitialDataForLoad(props));
            }
            else (
                this.setState({page: "StoreItemsScreen"})
            )
        }
    };

    getScreen = () => {
        switch (this.state.page) {
            case "ErrorFetching":
                return (<div/>);
            case "MessagePage" :
                return (<MessagePage
                    messageData={this.props.messageData}
                    memberKey={this.props.memberDetails.key}
                    action={this.props.messageData.allowContinue ? {text: "Continue", callback:this.props.closeMessage, type: 'button'} : undefined}
                />);
            case "StoreCheckOutScreen":
                return (<StoreCheckOutScreen staticData={this.props.staticData}/>);
            case "LogInScreen":
                return (<LogInScreen/>);
            case "ThankYouPage":
                return (
                    <ThankYouPage farmUrl={this.props.staticData.farmUrl} seasonUrl={this.props.staticData.seasonUrl}
                                  thankYouMessage={this.props.thankYouMessage}
                                  extraMessage={(this.props.staticData.params || {}).message}
                                  goBack={this.getPath} pageContext={URLs.STORE}
                                  memberKey={this.props.memberDetails.key}/>);
            case "EcheckForm":
                return (<EcheckForm pageContext={URLs.STORE}/>);
            case "EBTForm":
                return (<EBTForm pageContext={URLs.STORE}/>);
            case "PaymentsHost":
                return (<PaymentsHost pageContext={URLs.STORE}/>);
            case "LoadingAnimation":
                return (<LoadingAnimation/>);
            case "StoreItemsScreen":
                return (<StoreItemsScreen category={this._getCategoryFromLocation(this.props)}
                                          itemKey={this._getItemFromLocation(this.props)}
                                          enterBy={this._getOrigin()}
                                          staticData={ this.props.staticData}
                                          isStoreClosedWithMultiOrders={(this.props.messageData || {}).isStoreClosedWithMultiOrders}/>);
        }
    };
    render() {
		return (
		    this.getScreen()
		)
	}
}

const mapStateToProps = (state) => {
    return {
        staticData: state.staticData,
        isLoadingStoreData: isFetching(state, FetchingTypes.LOAD_STORE_DATA),
        errorFetching: (state.fetching || {}).error,
        memberDetails: (state.memberDetails || {}),
		shouldReloadData: (state.orderStatus||{}).shouldReloadData,
        currentOrder: (state.orderStatus||{}).currentOrder,
        orderStatus: (state.orderStatus||{}),
        messageData: state.messageData,
        thankYouMessage: (state.orderStatus || {}).message
    };
};

const mapDispatchToProps = (dispatch) => {
	return {
        initServerStaticData: () => {
            dispatch(initServerStaticData());
        },
        initMemberData: () => {
          dispatch(initMemberData());
        },
        setAndRemoveUrlParams: (onlyHidden) => {
          dispatch(setAndRemoveUrlParams(onlyHidden));
        },
		onLoad: (initialData) => {
			dispatch(loadData(initialData));
		},
        setShouldReloadData: (shouldReloadData) => {
            dispatch(setShouldReloadData(shouldReloadData));
        },
        restoreOrder: () => {
            dispatch(setDirty(true));
        },
        closeMessage: () => {
            dispatch(setMessageData({}))
        }
	}
};

export default connect(mapStateToProps, mapDispatchToProps)( StoreHomeScreen );


// WEBPACK FOOTER //
// ./src/containers/store/StoreHomeScreen.js